export default "__VITE_ASSET__29e42f57__"